import React, { useContext } from 'react';
import enterIcon from '../../images/enterIcon.png';
import { motion } from 'framer-motion';
// import EdvesSvg from '../../SVGs/edvesSvg';
import WhiteEdvesLogo from '../../SVGs/WhiteEdvesLogo';
import { FetchContext } from '../../Context/fetchContext';
import sanwoOlu from '../../images/sanwoOlu.jpg'
import frame from '../../images/Frame.png'

const ImageSectionCustom = ({headingText, subHeadingText, subHeadingHighlight, img, frameImage}) => {
    const fetchContext = useContext(FetchContext);
    const host = fetchContext.host;

    const Heading = () => (
        <span className='font-bold text-3xl leading-9'> {headingText} </span>
    );
    
    const SubHeading = () => (
        <div className='text-p font-normal w-full'> 
            <span className='text-lg font-bold'>
                {subHeadingHighlight}
            </span> {subHeadingText} 
        </div>
    );

    const iconVariants = {
        hidden: {
            opacity: 0,
            scale: 0
        },
        visible: {
            opacity: 1,
            transition: {
                delay: 2
            },
            scale: [1, 1.5, 1, 1.5, 1]
        }
    }
    return (
        <motion.div  
            animate={{ opacity:1 }} 
            initial={{ opacity:0 }} 
            transition={{ duration:.1 }} 
            className='h-screen w-full relative'
        >
            { host !== 'lasgeduhub.edves.net' ? 
            <span className='flex-shrink w-full'>
                {/* <img src={img} alt="relevantPic" className='relative bg-clip-content w-full h-full' />    */}
            </span> :
            <span className='flex-shrink w-full'>
                <img src={sanwoOlu} alt="relevantPic" className='absolute bg-cover inset-0 w-full h-full' />   
                <div className = 'inset-0 absolute w-full h-full bg-primary bg-opacity-70'></div>
                <div className = 'inset-0 absolute w-full h-full bg-headingDark bg-opacity-40'></div>
            </span>
            }


            <div className='absolute inset-0 text-white flex items-center'>
                <div className={`${host === 'lasgeduhub.edves.net' ? 'mt-40' : 'mt-0'} mx-8 `}>
                {/* <div className='mt-32 mx-12 w-full'> */}

                <img src={frameImage ?? frame} alt='frame' className='mb-6' style={{maxHeight: '220px'}} />
                <div className='w-full'>
                    <Heading />

                    </div>

                    <div className='mt-6 w-full space-x-3 flex items-start'>
                        <motion.span variants={iconVariants} className='mt-1 flex-shrink-0'>
                            <img src={enterIcon} alt='enterIcon' />
                        </motion.span>
                        <SubHeading />
                    </div>
                </div>
            </div>
            {/* <div className='bottom-4 left-12 right-60 absolute text-white text-p font-bold'>  */}
           
        </motion.div>
    ) //bg-cover object-contain
}

export default ImageSectionCustom;